import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountDetailFragment = { __typename?: 'Account', id: number, email: string };

export type GetCurrentAccountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentAccountQuery = { __typename?: 'Query', getCurrentAccount?: { __typename?: 'Account', id: number, email: string } | null };

export type UpdateCurrentAccountMutationVariables = Types.Exact<{
  organisationId: Types.Scalars['String']['input'];
}>;


export type UpdateCurrentAccountMutation = { __typename?: 'Mutation', updateCurrentAccounts?: { __typename?: 'UpdateCurrentAccountsPayload', account?: { __typename?: 'Account', id: number, email: string } | null } | null };

export const AccountDetailFragmentDoc = gql`
    fragment AccountDetail on Account {
  id
  email
}
    `;
export const GetCurrentAccountDocument = gql`
    query GetCurrentAccount {
  getCurrentAccount {
    ...AccountDetail
  }
}
    ${AccountDetailFragmentDoc}`;

/**
 * __useGetCurrentAccountQuery__
 *
 * To run a query within a React component, call `useGetCurrentAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentAccountQuery, GetCurrentAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentAccountQuery, GetCurrentAccountQueryVariables>(GetCurrentAccountDocument, options);
      }
export function useGetCurrentAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentAccountQuery, GetCurrentAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentAccountQuery, GetCurrentAccountQueryVariables>(GetCurrentAccountDocument, options);
        }
export function useGetCurrentAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentAccountQuery, GetCurrentAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentAccountQuery, GetCurrentAccountQueryVariables>(GetCurrentAccountDocument, options);
        }
export type GetCurrentAccountQueryHookResult = ReturnType<typeof useGetCurrentAccountQuery>;
export type GetCurrentAccountLazyQueryHookResult = ReturnType<typeof useGetCurrentAccountLazyQuery>;
export type GetCurrentAccountSuspenseQueryHookResult = ReturnType<typeof useGetCurrentAccountSuspenseQuery>;
export type GetCurrentAccountQueryResult = Apollo.QueryResult<GetCurrentAccountQuery, GetCurrentAccountQueryVariables>;
export const UpdateCurrentAccountDocument = gql`
    mutation UpdateCurrentAccount($organisationId: String!) {
  updateCurrentAccounts(input: {organisationId: $organisationId}) {
    account {
      ...AccountDetail
    }
  }
}
    ${AccountDetailFragmentDoc}`;

/**
 * __useUpdateCurrentAccountMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentAccountMutation, { data, loading, error }] = useUpdateCurrentAccountMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useUpdateCurrentAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentAccountMutation, UpdateCurrentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentAccountMutation, UpdateCurrentAccountMutationVariables>(UpdateCurrentAccountDocument, options);
      }
export type UpdateCurrentAccountMutationHookResult = ReturnType<typeof useUpdateCurrentAccountMutation>;
export type UpdateCurrentAccountMutationResult = Apollo.MutationResult<UpdateCurrentAccountMutation>;
export type UpdateCurrentAccountMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentAccountMutation, UpdateCurrentAccountMutationVariables>;